import { render, staticRenderFns } from "./ActivitiesListingMassAssign.vue?vue&type=template&id=ed81668a&"
import script from "./ActivitiesListingMassAssign.vue?vue&type=script&lang=js&"
export * from "./ActivitiesListingMassAssign.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesListingMassAssign.vue?vue&type=style&index=0&id=ed81668a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports